import React from "react";
import "./style.css"
import Typography from '@mui/material/Typography';
import { Container, useMediaQuery } from "@mui/material";
import { i18n } from "../../translate/i18n";
import Lottie from 'react-lottie';
import checkmark from '../../lotties/checkmark.json';

const Verificacao = () => {
  const isSmallScreen = useMediaQuery('(max-width:825px)');
  const defaultOptions = {
    animationData: checkmark,
    loop: false,
    background:'transparent',
    speed:'1', 
    direction:'1', 
    playMode:'normal',
    autoplay: true,
  }

  return (    
    <div className="verification-backGround">

        <Container className={isSmallScreen ? "verificarionSmall" : "verificarionDesktop"}>
          <div className={isSmallScreen ? "checkContainerSmall" : "checkContainer"}>
            <Lottie 
              options={defaultOptions}
              height={200}
              width={200}
            />
          </div>

          <div className={isSmallScreen ? "textContainerSmall" : "textContainer"}>
            <Typography id="tituloFirst">{i18n.t("verification.title")}</Typography>
            <Typography id="tituloSecond">{i18n.t("verification.message")}</Typography>
          </div>
        </Container>      
    </div>
  );
};

export default Verificacao;
